import { Language } from '../utils/i18n.utils';

export const LicenseConstants = {
  InfoLinks: {
    CoreOnlineProduct: {
      [Language.French]: 'https://www.bitdefender.fr/business/products/gravityzone-small-business-security.html',
      [Language.German]: 'https://www.bitdefender.de/business/products/gravityzone-small-business-security.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/products/gravityzone-small-business-security.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/products/gravityzone-small-business-security.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/products/gravityzone-small-business-security.html',
      [Language.Default]: 'https://www.bitdefender.com/business/products/gravityzone-small-business-security.html',
    },
    Elite: {
      [Language.French]: 'https://www.bitdefender.fr/business/products/gravityzone-premium-security.html',
      [Language.German]: 'https://www.bitdefender.de/business/products/gravityzone-premium-security.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/products/gravityzone-premium-security.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/products/gravityzone-premium-security.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/products/gravityzone-premium-security.html',
      [Language.Default]: 'https://www.bitdefender.com/business/products/gravityzone-premium-security.html',
    },
    OfficeSecurityPack: {
      [Language.French]: 'https://www.bitdefender.fr/business/smb-products/business-security.html',
      [Language.German]: 'https://www.bitdefender.de/business/smb-products/business-security.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/smb-products/business-security.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/smb-products/business-security.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/smb-products/business-security.html',
      [Language.Default]: 'https://www.bitdefender.com/business/smb-products/business-security.html',
    },
    Atd: {
      [Language.French]: 'https://www.bitdefender.fr/business/products/gravityzone-enterprise-security.html',
      [Language.German]: 'https://www.bitdefender.de/business/products/gravityzone-enterprise-security.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/products/gravityzone-enterprise-security.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/products/gravityzone-enterprise-security.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/products/gravityzone-enterprise-security.html',
      [Language.Default]: 'https://www.bitdefender.com/business/products/gravityzone-enterprise-security.html',
    },
    FullDiskEncryption: {
      [Language.French]: 'https://www.bitdefender.fr/business/gravityzone-addons/full-disk-encryption.html',
      [Language.German]: 'https://www.bitdefender.de/business/gravityzone-addons/full-disk-encryption.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/gravityzone-addons/full-disk-encryption.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/gravityzone-addons/full-disk-encryption.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/gravityzone-addons/full-disk-encryption.html',
      [Language.Default]: 'https://www.bitdefender.com/business/gravityzone-addons/full-disk-encryption.html',
    },
    PatchManagement: {
      [Language.French]: 'https://www.bitdefender.fr/business/gravityzone-addons/patch-management.html',
      [Language.German]: 'https://www.bitdefender.de/business/gravityzone-addons/patch-management.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/gravityzone-addons/patch-management.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/gravityzone-addons/patch-management.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/gravityzone-addons/patch-management.html',
      [Language.Default]: 'https://www.bitdefender.com/business/gravityzone-addons/patch-management.html',
    },
    SecurityForStorage: {
      [Language.French]: 'https://www.bitdefender.fr/business/enterprise-products/security-for-storage.html',
      [Language.German]: 'https://www.bitdefender.de/business/enterprise-products/security-for-storage.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/enterprise-products/security-for-storage.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/enterprise-products/security-for-storage.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/enterprise-products/security-for-storage.html',
      [Language.Default]: 'https://www.bitdefender.com/business/enterprise-products/security-for-storage.html',
    },
    EmailSecurity: {
      [Language.French]: 'https://www.bitdefender.fr/business/gravityzone-addons/email-security.html',
      [Language.German]: 'https://www.bitdefender.de/business/gravityzone-addons/email-security.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/gravityzone-addons/email-security.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/gravityzone-addons/email-security.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/gravityzone-addons/email-security.html',
      [Language.Default]: 'https://www.bitdefender.com/business/gravityzone-addons/email-security.html',
    },
    MobileSecurity: {
      [Language.French]: 'https://www.bitdefender.fr/business/gravityzone-addons/security-for-mobile.html',
      [Language.German]: 'https://www.bitdefender.de/business/gravityzone-addons/security-for-mobile.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/gravityzone-addons/security-for-mobile.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/gravityzone-addons/security-for-mobile.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/gravityzone-addons/security-for-mobile.html',
      [Language.Default]: 'https://www.bitdefender.com/business/gravityzone-addons/security-for-mobile.html',
    },
    FRAT: 'https://download.bitdefender.com/business/FRAT/Bitdefender_GravityZone_FreeRiskAssessmentTool_enUS.pdf',
    CloudSecurityMsp: {
      [Language.French]: 'https://www.bitdefender.fr/business/service-providers-products/cloud-security-msp.html',
      [Language.German]: 'https://www.bitdefender.de/business/service-providers-products/cloud-security-msp.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/service-providers-products/cloud-security-msp.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/service-providers-products/cloud-security-msp.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/service-providers-products/cloud-security-msp.html',
      [Language.Default]: 'https://www.bitdefender.com/business/service-providers-products/cloud-security-msp.html',
    },
    BitdefenderEdr:
      'https://www.bitdefender.com/business/support/en/77211-92418-bitdefender-edr-standalone-for-msp-faq.html',
    HowToCalculateMonthlyUsage:
      'https://www.bitdefender.com/business/support/en/77211-80017-calculating-the-endpoint-usage-with-the-monthly-license-usage-report.html',
    MdrServiceFaq:
      'https://www.bitdefender.com/business/support/en/77211-129250-bitdefender-managed-detection-and-response-for-msp-service-faq.html',
    XDRConfiguration: 'https://www.bitdefender.com/business/support/en/77211-151141-edr-configuration.html',
    BundlesDetails: 'https://www.bitdefender.com/business/support/en/77211-354270-protection-models-faq.html',
    EmailRedactionForGravityZone:
      'https://www.bitdefender.com/business/support/en/77209-295106-email-redaction-for-email-security-accounts.html',
    CompareProducts: {
      [Language.French]: 'https://www.bitdefender.fr/business/compare.html',
      [Language.German]: 'https://www.bitdefender.de/business/compare.html',
      [Language.Spanish]: 'https://www.bitdefender.es/business/compare.html',
      [Language.Italian]: 'https://www.bitdefender.it/business/compare.html',
      [Language.Romanian]: 'https://www.bitdefender.ro/business/compare.html',
      [Language.Russian]: 'https://www.bitdefender.ru/business/compare.html',
      [Language.Portuguese]: 'https://www.bitdefender.pt/business/compare.html',
      [Language.Default]: 'https://www.bitdefender.com/business/compare.html',
    },
    LicenseActivationEffectiveDateFaq: 'https://www.bitdefender.com/business/support/en/77211-957461-yearly-licensing-activation-effective-date-faq.html'
  },

  MonthlySubscription: {
    ReserveSeats: {
      Default: 0,
      MinInput: 0,
      MinValidator: 1,
    },

    MinimumUsage: {
      Default: 0,
      DisabledValue: 0,
      MinInput: 0,
      MinValidator: 1,
    },

    AutoRenewal: {
      Default: 12,
      DisabledValue: 0,
      MinValidator: 1,
      MinInput: 0,
      MaxValue: 100,
    },

    EndDate: {
      DisabledValue: 0,
    },
  },

  LicenseKeyLengthLV2: 7,
  LicenseKeyLengthSV4: 12,
};
